export default __webpack_public_path__ + "static/media/email.4792d3e0.svg";